<template>
  <div class="container">
    <div class="content">
      <div class="content-head">
        <div style="display: flex;justify-content: center;align-items: center;">
            <img src="@/assets/house/breadicon.png" style="margin-right:10px" alt="">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>资源管理</el-breadcrumb-item>
              <el-breadcrumb-item>审核列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="refresh">
          <el-button round size="large" type="warning" :loading="isRefresh" @click="refresh" icon="el-icon-refresh-left">刷新</el-button>
        </div>
      </div>
      <div class="content-search">
        <div class="search-form">
          <el-form  ref="searchFrom" :model="searchForm" label-suffix=":" label-width="100px">
          <el-row type="flex" align="center">
            <el-col :span="7">
                <el-form-item style="margin-bottom: 0;" label="资源集名称">
                    <el-input v-model="searchForm.keyword" placeholder="请输入资源集名称"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="7">
                <el-form-item style="margin-bottom: 0;" label="所属资源库">
                  <el-cascader
                    clearable
                    style="width: 100%;"
                    :show-all-levels="false"
                    v-model="searchForm.libId"
                    :options="searchLibList"
                    :props="searchLibListProp"
                  >
                  </el-cascader>
                </el-form-item>
            </el-col>
            <el-col :span="7">
                <el-form-item style="margin-bottom: 0;" label="上传时间">
                  <el-date-picker
                    clearable
                    style="width: 100%;"
                    v-model="searchForm.timeRange"
                    type="daterange"
                    value-format="timestamp"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
            </el-col>
            <!-- <el-col :span="7">
                <el-form-item label="上传人">
                    <el-input v-model="searchForm.createUid"></el-input>
                </el-form-item>
            </el-col> -->
            <el-col :span="3" style="display: flex;justify-content: flex-end;flex-wrap: nowrap;">
                <el-button type="warning" @click="search" round icon="el-icon-search">搜索</el-button>
                <el-button type="primary" round :loading="isRefresh" @click="refresh" icon="el-icon-refresh-left">重置</el-button>
            </el-col>
          </el-row>
          <!-- <el-row>
            
            
          </el-row> -->
        </el-form>
        </div>
      </div>
      <div class="content-body" v-loading="isLoading">
        <div class="table-body">
          <el-table :data="tableData"  
           border :height="windowHeight>900?650:550" style="width: 100%"
           @selection-change="handleSelectionChange">
           >
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column align="center" prop="name" show-overflow-tooltip label="资源集名称" width="300">
            </el-table-column>
            <el-table-column align="center" label="所属资源库" min-width="300">
              <template slot-scope="scope">
                {{ scope.row.libInfo.name }}
              </template>
            </el-table-column>
            <el-table-column label="上传人" align="center" min-width="100">
              <template slot-scope="scope">
                {{ scope.row.createUserInfo.name }}
              </template> 
            </el-table-column>
            <el-table-column label="送审时间" align="center" prop="submitAtMY" width="200"> </el-table-column>
            <el-table-column label="资源数" width="100" align="center">
              <template slot-scope="scope">
                {{ scope.row.pictureCount + scope.row.videoCount}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="300" align="center">
              <template slot-scope="scope">
                <el-button @click="openDialog(scope.row)"  type="text" icon="el-icon-view" >查看</el-button>
                <el-button @click="openBoxOfPass(scope.row,'single',true)"  type="text" icon="el-icon-s-check" style="color:#74ba36 !important">审核通过</el-button>
                <el-button @click="openBoxOfPass(scope.row,'single',false)" type="text" icon="el-icon-document-delete" style="color:#f56c6c !important">驳回</el-button>
              </template>
            </el-table-column>
          </el-table>
          
        </div>
        <div class="pagination">
          <div>
            <el-button type="primary" :disabled="multipleSelectedIds.length==0" @click="openBoxOfPass(multipleSelectedIds,'batch',true)" icon="el-icon-s-check" round>批量通过</el-button>
            <el-button type="danger" :disabled="multipleSelectedIds.length==0" @click="openBoxOfPass(multipleSelectedIds,'batch',false)" round icon="el-icon-document-delete">批量驳回</el-button>
          </div>
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageable.page"
            :page-sizes="[10, 15, 50, 100]"
            :page-size="pageable.pageSize"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listLib } from '@/api/lib.js'
import { searchAtlas } from '@/api/search.js'
import { formatConversion } from "@/plugins/getdate";
import { batchCheck } from "@/api/file.js";
import { allowLib } from "@/constants/powers";
export default {
  inject: ['reload'],
  components: {
    
  },
  watch: {
    windowHeight: {
      handler: function(newVal, oldVal) {
      let that = this;
      console.log(newVal,that.windowHeight);
    },immediate:true
      
    }
  },
  data() {
    return {
            //权限
      allowLib,

            //图集信息
      atlasForm: {
        libId: "",
        name: "",
        desc: "",
        status: "",
        sourceType: "0",
        indexpicId: "0",
        createUid: this.createUid,
      },
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
      isLoading: false,
      isRefresh: false,
      // 搜索参数收集
      searchForm: {
        keyword:"",
        libId: "",
        createUid:"",
        timeStart: "",
        timeEnd: "",
        timeRange:[]
      },
      // 搜索参数汇总
      searchParams: {  status:"",statusInfo:2,keyword:"", libId: "", createUid: "", timeStart: "", timeEnd: "",},
      pageable: {
        pageSize: 10,
        page: 0,
      },
      total:0,

      
      searchLibList:[],   // 搜索资源库列表
      searchLibListProp: {
        emitPath: false,
        value: 'id',
        label:'name'
      },
      // 表格数据
      tableData: [],
      // 表格配置
      config: {
        isSelection: true,       //显示复选框
					isRowClick: false,       //使用行点击
					isStripe: false,         //隐藏斑马纹，与背景色不可同时用
					tableHeight: 520,        //表格高度
					isShowSummary: true,     //显示共计
					isIndex:false,           //自定义序号
      },
      
      multipleSelection:[]
    }
  },
  computed: {
    multipleSelectedIds() {
      let ids = [];
      this.multipleSelection.forEach(item => {
        ids.push(item.id);
      });
      return ids 
    }
  }
  ,
  methods: {
    openDialog(rowData) {
      this.$router.push({
        name: "myLibShow", //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          id: rowData.id,
          fromPath:this.$route.path
        }
      });
    },
    openBoxOfPass(rowData, flag,isPass) {
      if (isPass) {
        console.log(rowData);
        this.$confirm(`${flag=='batch'?'已选中':'当前'}资源尚未评级，通过后评级将默认为基础评级，是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.checkPassFun(rowData,flag,isPass,'')
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
      } else {
        this.$prompt('请输入驳回原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: "textarea",
        })
          .then(({ value }) => {
            this.checkPassFun(rowData,flag,isPass, value||'')
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });       
        });
      }
        
    },
    async checkPassFun(_rowData, flag,isPass,_value) {
      console.log(_rowData, flag, _value);
      // 通过 status  3
      let params = {}
      if (isPass) {
        params.status = 3;
        // 单个通过
        if (flag=='single') {
            params.atlasIds=_rowData.id
          
        } else {
          // 批量通过
            params.atlasIds=_rowData.join(',')
        }
      }
      // 驳回  status  4
      else {
        params.status = 4;
        // 单个
        if (flag == 'single') {
          params.atlasIds = _rowData.id,
          params.rejectRes=_value
        } else {
          // 批量
          params.atlasIds = _rowData.join(',')
          params.rejectRes=_value
        }
      }
      try {
        let { status, message } = await batchCheck(params)
        if (status) {
          this.$message.success(message)
          this.pageable.page -=1 
          this.getCheckAtlasList(Object.assign(this.searchParams,this.pageable)) 
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        this.$message.error(error)
      }
    },

    // 搜索参数
    search() {
      this.searchForm.timeStart=this.searchForm.timeRange.length==0?"": this.searchForm.timeRange[0]/1000
      this.searchForm.timeEnd =this.searchForm.timeRange.length==0?"": this.searchForm.timeRange[1] / 1000
      this.searchParams.keyword = this.searchForm.keyword
      this.searchParams.timeStart= this.searchForm.timeStart
      this.searchParams.timeEnd = this.searchForm.timeEnd
      this.searchParams.createUid = this.searchForm.createUid
      this.searchParams.libId = this.searchForm.libId
      this.pageable.page=0
      console.log(Object.assign(this.searchParams,this.pageable));
      // this.getCheckAtlasList(this.searchParams)
      this.getCheckAtlasList(Object.assign(this.searchParams,this.pageable))

    },
    handleSizeChange(val) {
      this.pageable.pageSize = val
      this.pageable.page=0
      console.log(`每页 ${val} 条`);
      console.log(Object.assign(this.searchParams,this.pageable));

    this.getCheckAtlasList(Object.assign(this.searchParams,this.pageable))

    },
    handleCurrentChange(val) {
      this.pageable.page=val-1
      console.log(`当前页: ${val}`);
      console.log(Object.assign(this.searchParams,this.pageable));

    this.getCheckAtlasList(Object.assign(this.searchParams,this.pageable))

    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
        console.log(val);
    },
    // 刷新
    refresh() {
      this.isRefresh = true
      this.searchForm.keyword=""
      this.searchForm.timeStart=""
      this.searchForm.timeEnd=""
      this.searchForm.createUid=""
      this.searchForm.libId = ""
      this.searchForm.timeRange = []
      this.searchParams.keyword=""
      this.searchParams.timeStart=""
      this.searchParams.timeEnd=""
      this.searchParams.createUid=""
      this.searchParams.libId=""
      this.pageable.page=0,
      this.pageable.pageSize = 10,
      this.getCheckAtlasList(Object.assign(this.searchParams,this.pageable))
      
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },
    // 获取资源库列表
    async getLibList() {
      //old 获取option
      // let params = {
      //   page:0,
      //   pageSize:200
      // }
      // let { data } = await listLib(params)
      //    let filterData = data.filter((element)=>element.parentId==0)
      //    filterData.forEach(element => {
      //       if (element.children.length == 0) {
      //         delete element.children
      //       }
      //     });
      //   console.log(filterData);
      // this.searchLibList = filterData

      //new 获取option方法

     let { status, data, message } = await listLib({ pageSize: 1000 });
      if (status) {
        this.searchLibList = [];
      if (localStorage.getItem("createUid") == 60000) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].status === 1) {
            this.searchLibList.push({
              id: data[i].id,
              name: data[i].name,
              children:[]
            });
          }
        }
      } else {
        for (let i = 0; i < data.length; i++) {
          if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
            if (data[i].status === 1) {
              this.searchLibList.push({
                id: data[i].id,
                name: data[i].name,
                children:[]
              });
            }
          }
        }
      }
      if (this.$route.params.atlas) {
        if(this.$route.params.atlas.parentLibId == 0){
          this.atlasForm.libId = this.$route.params.atlas.libId;
        }else{
          this.atlasForm.libId = [this.$route.params.atlas.parentLibId,this.$route.params.atlas.libId.toString()];
        }
      } else if (this.searchLibList.length > 0) {
        this.atlasForm.libId = this.searchLibList[0].id;
      }


      for (let i = 0;i < this.searchLibList.length;i++) {
        let flag = 0
          for (let j = 0; j < this.allowLib.length; j++) {
            if(this.allowLib[j].toString().indexOf('-') !== -1){
              if(this.searchLibList[i].id == this.allowLib[j].split('-')[0]){
                flag++
                this.searchLibList[i].children.push({
                  id: this.allowLib[j].split('-')[1],
                  name: ''
                })
              }
            }
            
          }
          if(flag == 0){
            delete this.searchLibList[i].children
          }
      }

      for (let i = 0; i < this.searchLibList.length; i++) {
        if(this.searchLibList[i].hasOwnProperty('children')){
          if(this.searchLibList[i].children.length > 0){
            let spliceNum = []
            for (let z = 0; z < this.searchLibList[i].children.length; z++) {
              for (let j = 0; j < data.length; j++) {
                if(data[j].id == this.searchLibList[i].children[z].id){
                  if(data[j].status === 1){
                    this.searchLibList[i].children[z].name = data[j].name
                  }else{
                    spliceNum.push(z)
                  }
                }
                
              }
              
            }

            for (let index = 0; index < spliceNum.length; index++) {
              this.searchLibList[i].children.splice(spliceNum[index] - index,1)
            }
          
            //没有子集 删除children
            if (this.searchLibList[i].children.length == 0) {
                delete this.searchLibList[i].children;
            }
          }
        }
      }
      } else {
        this.$message.error('【归属资源库】模块'+message);
      }
      
      
    },


    //获取待审核资源集列表
    async getCheckAtlasList(params) {
      try {
        this.isLoading=true
        let {data,status,message,pagination} = await searchAtlas(params)
        if (status) {
          data.forEach((element) => {
            element.createAtMY=formatConversion(element.createAt.toString())
            element.submitAtMY=formatConversion(element.submitAt.toString())
            // element.createAtMy=formatDate( element.createAt,"yyyy-MM-dd  hh:mm:ss")
            console.log(element);

          })
          this.tableData = data

          this.pageable.page =pagination.page+1
          this.pageable.pageSize = pagination.pageSize
          this.total = pagination.total
          this.isLoading=false
        } else {
          this.$message.error(message)
          this.isLoading=false
        }
      } catch (error) {
        this.$message.error(error.message)
        this.isLoading=false
      }

    },

  },
  created() {
    var that = this;
        // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
              window.fullHeight = document.documentElement.clientHeight;
                window.fullWidth = document.documentElement.clientWidth;
              that.windowHeight = window.fullHeight;  // 高
              that.windowWidth = window.fullWidth; // 宽
            })()
          };
    this.getLibList()
    console.log(Object.assign(this.searchParams,this.pageable));

    this.getCheckAtlasList(Object.assign(this.searchParams,this.pageable))
   },
  
}
</script>

<style lang="scss" scoped>
@import "./need-check.scss";
  
</style>